// extracted by mini-css-extract-plugin
export default {"header":"UserList_header__61st1","item":"UserList_item__9eW6e"};